import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  border-radius: 5px;
  background-color: #fff;
  height: auto;
`;

export const Header = styled.div`
  padding: 12px 27px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid #ececec;
`;

export const QuestionList = styled.div`
  padding: 12px 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
